import * as Sentry from "@sentry/react";

export const setupSentry = ({
  sentry_dsn,
  sentry_environment,
}: {
  sentry_dsn: string;
  sentry_environment: string;
}) => {
  const dsn = sentry_dsn || import.meta.env.VITE_SENTRY_DSN;
  const environment =
    sentry_environment || import.meta.env.VITE_SENTRY_ENVIRONMENT;
  const isLocalhost = window.location.hostname === "localhost";
  if (!dsn || !environment || isLocalhost) return;
  Sentry.init({
    dsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // enabled: import.meta.env.VITE_WITH_SENTRY === "true",
    environment,
    // Add optional integrations for additional features
    integrations: [
      Sentry.replayIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({
        levels: ["error"],
      }),
    ],
    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 1.0,
    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    enableLogs: true,
  });
};
